export const isSessionDel = (value: string) => {
  const sessionKeys = Object.keys(sessionStorage)
  for (let i = 0; i < sessionKeys.length; i++) {
    // 可以对key 进行分析从而决定是否要删除sessionStorage 里的缓存
    if (!sessionKeys[i].includes(value)) {
      sessionStorage.removeItem(sessionKeys[i])
    }
  }
}
